module.exports = __webpack_public_path__ + "img/long_logo.5cfe0993.png";